module.exports = __webpack_public_path__ + "img/BE_BC_Back.60b34385.png";